import axiosInstance from "@/api/axios";


  export const  fetchEmailemplate = async (query: {
  page: number;
  limit: number;
  q?: string | number;
  
}) => {
    try {
      const response = await axiosInstance({
        method: "GET",
        url: `/odoo/api/v1/emailTemplates`,
        params: {
        page: query.page,
        limit: query.limit,
        ...(query.q && { q: query.q }), 
       
       },
      });
  
      console.log("Response:", response);
      return response.data;
    } catch (err) {
      console.error("Error fetching stage details:", err);
      throw err;
    }
  };

  export const createEmailTemplate = async (data: object) => {
  try {
    // console.log(data,"line 22")
    const response = await axiosInstance({
      method: "POST",
      url: "/odoo/api/v1/emailTemplates",
      data,
    });

    console.log(" API Response:", response);
    return response.data;
  } catch (err) {
    console.error("Error fetching stage details:", err);
    throw err;
  }
};

export const UpdateEmailTemplate = async (
  templateId: number,
  updates: { name: string; subject: string; body_html: string }
) => {
  try {
    // console.log(data,"line 22")
    const response = await axiosInstance({
      method: "PUT",
      url: "/odoo/api/v1/emailTemplates",
          data: {
        templateId,
        updates,
      },
    });

    console.log(" API Response:", response);
    return response.data;
  } catch (err) {
    console.error("Error fetching stage details:", err);
    throw err;
  }
};

export const DeleteEmailTemplate = async (templateId:number) => {
  try {
    const response = await axiosInstance({
      method: "POST",
      url: `/odoo/api/v1/emailTemplates/delete`,
      params: { templateId },
    });
    console.log("response", response);
    return response.data;
  } catch (err) {
    console.log("err", err);
  }}
  
export const getEmailTemplateValues = async () => {
  try {
    // console.log(data,"line 22")
    const response = await axiosInstance({
      method: "GET",
      url: "/odoo/api/v1/emailTemplates/getValues",
      // data,
    });

    console.log(" API Response:", response);
    return response.data;
  } catch (err) {
    console.error("Error fetching stage details:", err);
    throw err;
  }
};